import { ExperimentationActions, ExperimentationState, ExperimentationToggle } from '@interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import { UpdateExperimentationToggle } from '@store/actions';

export const initialState: ExperimentationState = {
  [ExperimentationToggle.CWP_OPEN_CHOICE_MINOR]: false,
};

const experimentationToggleReducer = createReducer<
  ExperimentationState,
  Action<ExperimentationActions>
>(
  initialState,
  on(UpdateExperimentationToggle, (state, payload) => {
    return {
      ...state,
      [payload.toggle]: payload.value,
    };
  }),
);

export const reducer = (state: ExperimentationState, action: Action<ExperimentationActions>) => {
  return experimentationToggleReducer(state, action);
};
